import { gql } from "@outschool/ui-apollo";
import { ActivityListingFragment } from "@outschool/ui-components-website";

import { SavedActivityFragment } from "./fragments";

export const SavedClassListQuery = gql`
  query SavedClassListQuery(
    $listUid: String
    $order: String
    $searchFilters: SearchFilters!
    $limit: Int
    $offset: Int
    $skipRating: Boolean!
    $skipSavedActivities: Boolean
    $showListsForUserAndLearners: Boolean
  ) {
    savedClassList(
      listUid: $listUid
      order: $order
      skipSavedActivities: $skipSavedActivities
    ) {
      uid
      name
      privacyStatus
      ownerUid
      activityCount(countForUserAndLearnerLists: $showListsForUserAndLearners)
      listings(
        searchFilters: $searchFilters
        limit: $limit
        offset: $offset
        showListsForUserAndLearners: $showListsForUserAndLearners
      ) {
        ...ActivityListing_listing
      }
      owner {
        uid
        publicName
        leader {
          uid
          leader_link
        }
      }
    }
    currentUser {
      uid
      learners {
        uid
        name
        savedClassList {
          uid
        }
      }
      savedClassLists {
        uid
        name
        activityCount(countForUserAndLearnerLists: false)
      }
      userDefaultSavedClassList {
        uid
        activityCount(countForUserAndLearnerLists: true)
      }
    }
  }
  ${ActivityListingFragment}
`;

export const CurrentUserSavedActivitiesQueryStr = gql`
  query CurrentUserSavedActivities {
    currentUser {
      uid
      savedActivities {
        uid
        ...SavedActivityFragment
      }
    }
  }
  ${SavedActivityFragment}
`;

export const ListCurrentUserSavedClassLists = gql`
  query ListCurrentUserSavedClassLists {
    currentUser {
      uid
      savedClassLists {
        uid
        name
        lastAddedToAt
      }
    }
  }
`;
